export default __webpack_public_path__ + "static/media/AM_icon_FINAL_black.ea30ef38.svg";